/**
 * Login popup — `.open-login` trigger + `.login-popup` + `.login-modal`.
 * Port 1:1 din legacy common.js lines 2643-2669.
 */

import { $ } from '../core/selector.js';

export function initLogin(): void {
    const loginPopup = $('.login-popup') as HTMLElement | null;
    const loginModal = $('.login-modal') as HTMLElement | null;
    if (!loginPopup || !loginModal) return;

    ($('.open-login') as Element | null)?.on('click', function () {
        loginModal.style.display = 'block';
        loginModal.classList.add('modal-show');
        loginPopup.style.display = 'block';
        setTimeout(() => loginPopup.classList.add('popup-show'), 0);
    });

    loginPopup.on('click', 'a.close', function () {
        loginModal.classList.remove('modal-show');
        loginPopup.classList.remove('popup-show');
        loginPopup.addEventListener('transitionend', () => {
            loginModal.style.display = 'none';
            loginPopup.style.display = 'none';
        }, { once: true });
    });
}
